import React from "react";
import "./Alert.scss";

import InfoIcon from "../../../../components/VectorIcons/InfoIcon";

export const Alert = ({ message }) => {
  return (
    <div className="alertContainer">
      <div className="alertIconContainer">
        <InfoIcon color="#ffa810" size={24} />
      </div>

      <div className="alertMessageContainer">
        <span className="alertMessage">{message}</span>
      </div>
    </div>
  );
};
